var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.selected && !_vm.multiple)?_c('span',{style:(_vm.selected.css)},[_c('i',{class:`mdi mdi-${_vm.selected.icon} mdi-18px`})]):_vm._e(),_vm._v(" "),(!_vm.selected && !_vm.multiple)?_c('i',{staticClass:"mdi mdi-plus mdi-18px s-icon"}):_vm._e(),_vm._v(" "),_c('s-select2',{style:(`width: ${_vm.multiple ? '300' : '200'}px; text-align: left;`),attrs:{"value":_vm.value,"required":"","disabled":_vm.disabled,"multiple":_vm.multiple,"templateResult":_vm.templateResultTipo,"data":_vm.tiposHistoricos.map(ts => {
      ts.id = ts.name;
      ts.text = ts.name;
      return ts;
    })},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }